<template>
  <v-container>
    <v-row class="pt-8 black--text">
      <v-col class="custom-text text-center justify-center">
        Select a language
      </v-col>
    </v-row>
    <v-row v-if="languages.length < 4">
      <v-col class="text-center justify-center px-0">
        <Button
          v-for="language in languages"
          :key="language"
          :text="language"
          class="mx-1 mx-sm-2 mx-md-4 mx-lg-5 mx-xl-6"
          @click="() => selectLanguage(language)"
        />
      </v-col>
    </v-row>
    <v-row
      v-else
      class="black--text"
    >
      <v-col
        cols="12"
        sm="4"
        offset-sm="4"
        class="custom-text text-center justify-center"
      >
        <Select
          label="Languages"
          :items="languages"
          @input="selectLanguage"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, } from 'vuex';
  
import Select from '@/components/Select';
import Button from '@/components/Button';

export default {
  name: 'LanguageSelection',
  components: {
    Select,
    Button,
  },
  computed: {
    ...mapGetters(['languages',],),
  },
  methods: {
    ...mapActions({
      setLanguage: 'setLanguage',
      setStreamUrl: 'setStreamUrl',
      setVideoOnDemandUrl: 'setVideoOnDemandUrl',
    },),
    selectLanguage(language,) {
      this.setLanguage(language,);
      this.setStreamUrl(language,);
      this.setVideoOnDemandUrl(language,);
    },
  },
};
</script>